import { RefObject, useEffect, useState } from "react";

const useInViewport = (ref: RefObject<any>): boolean => {
    //check if we are in a browser or on a server
    if (typeof window === "undefined") {
        return false;
    }

    const [isIntersecting, setIntersecting] = useState<boolean>(false);
    const isSupported = "IntersectionObserver" in window;
    if (!isSupported) {
        console.error("IntersectionObserver is not supported in this browser");
        return false;
    }

    const observer = new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting));

    useEffect(() => {
        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => {
            observer.disconnect();
        };
    }, [ref.current]);

    return isIntersecting;
};

export default useInViewport;
